import React, { useContext } from "react";
import RdContext from "../../contexts/RdProvider";
import { RdContextType } from "../../@types/Rd";
import { InteractionType } from "@azure/msal-browser";
import { Button } from "react-bootstrap";

/**
 * Renders a drop down button with child buttons for logging in with a popup or redirect
 */
export const SignInButton = () => {
    const { Login } = useContext(RdContext) as RdContextType;
    return (
        <Button
            className="ml-auto"
            variant="secondary"
            title="Entrar"
            children="Entrar"
            onClick={() => Login(InteractionType.Redirect)}
        />
    )
}